import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { getIsNewOffering } from 'marketplace-ui-common/offerings/utils';
import { formatInstalls } from 'marketplace-ui-common/utils/installs';
import { jsx as _jsx } from "react/jsx-runtime";
const InstallCount = ({
  firstPublishedAt,
  installsCount
}) => {
  if (firstPublishedAt && getIsNewOffering(firstPublishedAt)) {
    return /*#__PURE__*/_jsx(Text, {
      as: "small",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'marketplace-ui-apps-core.appCard.new'
      })
    });
  }
  if (installsCount === undefined) return null;
  return /*#__PURE__*/_jsx(Text, {
    as: "small",
    use: "help",
    children: formatInstalls(installsCount)
  });
};
export default InstallCount;